// extracted by css-extract-rspack-plugin
export default {"Text":"RemovedFromProjectV2Event-module__Text__V0YCc","Text_1":"RemovedFromProjectV2Event-module__Text_1__HFm2x","Text_2":"RemovedFromProjectV2Event-module__Text_2__d81lJ"};